import React from 'react';


import iconCheck from '../../assets/images/icon/check.png';
import iconChecked from '../../assets/images/icon/checked.png';


type Props = {
	checked: boolean;
};


function CheckIcon({ checked }: Props) {
	return (
		<>
			{
				checked ? (
					<img src={iconChecked} alt="check" width="16" />
				) : (
					<img src={iconCheck} alt="check" width="16" />
				)
			}
		</>
	);
}

export default CheckIcon;